import { UIManager } from './register-ui.js';
import { apiService } from './register-api.js';
import { handleGetOTPClick, handleRegister, handleSubmitOTPClick } from './register-handlers.js';

class PhoneRegister extends HTMLElement {
    constructor() {
        super();
        this.ui = null;
    }

    connectedCallback() {
        this.ui = new UIManager(this);
        this.addEventListeners();
    }

    addEventListeners() {
        this.ui.elements.btnGetOTP.addEventListener('click', (event) => {
            handleGetOTPClick(event, this.ui, apiService);
        });

        this.ui.elements.btnSubmitOTP.addEventListener('click', (event) => {
            handleSubmitOTPClick(event, this.ui, apiService);
        });

        this.ui.elements.formRegister.addEventListener('submit', (event) => {
            handleRegister(event, this.ui, apiService);
        });

        // Handler sederhana bisa langsung didefinisikan di sini
        this.ui.elements.inputPhone.addEventListener('input', (event) => {
            const phoneValue = event.target.value;
            const hiddenPhoneInput = this.ui.elements.formRegister.querySelector('[name="customer[phone]"]');
            if (hiddenPhoneInput) {
                hiddenPhoneInput.value = phoneValue;
            }
        });

        // Handle agree to the terms
        this.ui.elements.agreeTerms.addEventListener('change', (event) => {
            const agreeValue = event.target.value
            if (agreeValue === "on") {
                this.ui.elements.btnRegister.disabled = false
            }
        })
    }
}

customElements.define('phone-register', PhoneRegister);